import { render, staticRenderFns } from "./EpochSelector.vue?vue&type=template&id=d420d840&"
import script from "./EpochSelector.vue?vue&type=script&lang=js&"
export * from "./EpochSelector.vue?vue&type=script&lang=js&"
import style0 from "./EpochSelector.vue?vue&type=style&index=0&id=d420d840&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports